import { SidebarBox } from 'components/Custom'
import { Box } from 'components/Material/Box'
import { BodyText } from 'components/Custom/Typographies'
import DocumentActions from './DocumentActions'
import DocumentStatusSelect, { StatusItem } from './DocumentStatusSelect'
import { DocumentApprovalType } from 'types/documentos'
import { DocumentStatus } from '../sidebars/DetailsSidebar'

interface DocumentItemProps {
  document: DocumentApprovalType
  index: number
  divider: boolean
  handleUploadFile: (document: DocumentApprovalType) => void
  handleDownloadFile: (document: DocumentApprovalType) => void
  handlerDelete: (document: DocumentApprovalType) => void
  handlerChangeStatus: (document: DocumentApprovalType, status: DocumentStatus) => void
  statusValue: (status: string, id_corcc080: number) => string | number
  checkIfDocumentToDelete: (id: number) => boolean
  mountTextUserDate: (date: string, user: string) => string
  LIST_DOCUMENT_STATUS_SELECT: StatusItem[]
  proposalStatus?: string
}

const DocumentItem = ({
  proposalStatus,
  document,
  index,
  divider,
  handleUploadFile,
  handleDownloadFile,
  handlerDelete,
  handlerChangeStatus,
  statusValue,
  checkIfDocumentToDelete,
  mountTextUserDate,
  LIST_DOCUMENT_STATUS_SELECT
}: DocumentItemProps) => {
  return (
    <SidebarBox className="w-full space-y-5" key={index} divider={divider}>
      <Box className="flex justify-between w-full">
        <BodyText text={document.nm_documento} typeStyle="large" className="self-center" />

        <DocumentActions
          proposalStatus={proposalStatus}
          document={document}
          handleUploadFile={handleUploadFile}
          handleDownloadFile={handleDownloadFile}
          handlerDelete={handlerDelete}
          checkIfDocumentToDelete={checkIfDocumentToDelete}
        />
      </Box>
      {document.id_corcc080 !== 0 && !checkIfDocumentToDelete(document.id_corcc080) && (
        <BodyText
          text={mountTextUserDate(document.dh_inclusao, document.nm_usuario_inclusao)}
          typeStyle="small"
        />
      )}
      <Box className="w-[350px]">
        <DocumentStatusSelect
          proposalStatus={proposalStatus}
          document={document}
          handlerChangeStatus={handlerChangeStatus}
          statusValue={statusValue}
          LIST_DOCUMENT_STATUS_SELECT={LIST_DOCUMENT_STATUS_SELECT}
          checkIfDocumentToDelete={checkIfDocumentToDelete}
        />
      </Box>
    </SidebarBox>
  )
}

export default DocumentItem
